function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tinymce from '@/components/Tinymce/index';
import { templateListApi, productCreateApi, categoryApi, productDetailApi, productUpdateApi } from '@/api/store';
import { marketingSendApi } from '@/api/marketing';
import { shippingTemplatesList } from '@/api/logistics';
import { goodDesignList } from "@/api/systemGroup";
import { clearTreeData } from '@/utils/ZBKJIutil';
import CreatTemplates from '@/views/systemSetting/logistics/shippingTemplates/creatTemplates';
import Templates from "../../appSetting/wxAccount/wxTemplate/index";
import { Debounce } from '@/utils/validate';
import * as systemConfigApi from '@/api/systemConfig';
import { checkPermi } from '@/utils/permission';
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  verticalPosterImage: '',
  storeName: '',
  storeInfo: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    // cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  // cost: {
  //   title: '成本价'
  // },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
export default {
  name: 'ProductProductAdd',
  components: {
    Templates: Templates,
    CreatTemplates: CreatTemplates,
    Tinymce: Tinymce
  },
  props: {
    //1 普通出售 2积分兑换 3租赁
    bizType: {
      default: null,
      type: Number
    },
    listUrl: {
      default: null,
      type: String
    }
  },
  data: function data() {
    return {
      tabIndex: this.$route.params.tabIndex,
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      activity: {
        '默认': 'red',
        '秒杀': 'blue',
        '砍价': 'green',
        '拼团': 'yellow'
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      checkboxGroup: [],
      recommend: [],
      tabs: [],
      fullscreenLoading: false,
      printInputType: 1,
      //1打印 2 装订
      props: {
        multiple: true
      },
      active: 0,
      customConfig: {},
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      ruleList: [],
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tempData: {
        page: 1,
        limit: 9999
      },
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: 0,
      isChoice: '',
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        storeName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        cateIds: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        keyword: [{
          required: true,
          message: '请输入此字段',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        storeInfo: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }]
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isAttr: false,
      showAll: false,
      videoLink: "",
      printCategoryPaperList: [],
      printCategoryWrapperList: [],
      currentPrintCategoryId: '',
      stepInput: true
    };
  },
  computed: {
    attrValue: function attrValue() {
      var item = {};
      if (this.customConfig.mallType == 1) {
        if (this.bizType == 3) {
          item = {
            price: 0,
            depositPrice: 0,
            stock: 0
          };
        } else {
          item = defaultObj.attrValue[0];
        }
      } else if (this.customConfig.mallType == 2) {
        item = {
          price: 0,
          stock: 0
        };
      }
      var obj = Object.assign({}, item);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj.attrValue[0])];
      delete obj[0].barCode;
      return obj;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        if (this.formValidate.specType && this.isAttr) this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    console.log('单');
    console.log(this.OneattrValue);
    console.log('多');
    console.log(this.ManyAttrValue);
    if (this.$route.params.id && this.formValidate.specType) {
      this.$watch('formValidate.attr', this.watCh);
    }
  },
  mounted: function mounted() {
    this.formValidate.sliderImages = [];
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
    } else {
      this.getCategorySelect();
      this.getCustomConfig();
    }
    this.getShippingList();
    this.getGoodsType();
  },
  methods: {
    modalPicTapPoster: function modalPicTapPoster() {
      var that = this;
      this.$modalUpload(function (img) {
        that.formValidate.verticalPosterImage = img[0].thumbnailPath;
      });
    },
    change: function change(value) {
      if (value) {
        this.formValidate.cateIds = [value];
      } else {
        this.formValidate.cateIds = [];
      }
    },
    onChangePrintInputType: function onChangePrintInputType(value) {
      this.currentPrintCategoryId = '';
      this.formValidate.cateIds = [];
      this.printInputType = value;
      console.log(value);
      if (value == 1) {
        this.formValidate.specType = true;
        this.initDefaultAttrs();
      } else {
        this.formValidate.specType = false;
        this.isAttr = false;
      }
    },
    // 校验输入框不能输入0，保留2位小数，库存为正整数
    keyupEvent: function keyupEvent(key, val, index, num) {
      if (key === 'barCode') return;
      var re = /^\D*([0-9]\d*\.?\d{0,2})?.*$/;
      switch (num) {
        case 1:
          if (val == 0) {
            this.oneFormBatch[index][key] = key === 'stock' || this.bizType === 2 ? 0 : 0.01;
          } else {
            this.oneFormBatch[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.oneFormBatch[index], key, val.toString().replace(re, '$1'));
          }
          break;
        case 2:
          if (val == 0) {
            this.OneattrValue[index][key] = key === 'stock' || this.bizType === 2 ? 0 : 0.01;
          } else {
            this.OneattrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.OneattrValue[index], key, val.toString().replace(re, '$1'));
          }
          break;
        default:
          if (val == 0) {
            this.ManyAttrValue[index][key] = key === 'stock' || this.bizType === 2 ? 0 : 0.01;
          } else {
            this.ManyAttrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.ManyAttrValue[index], key, val.toString().replace(re, '$1'));
          }
          break;
      }
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.isAttr = true;
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      // const route = Object.assign({}, this.tempRoute, { title: `${title}-${this.$route.params.id}` })
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    onChangeGroup: function onChangeGroup() {
      this.checkboxGroup.includes('isGood') ? this.formValidate.isGood = true : this.formValidate.isGood = false;
      this.checkboxGroup.includes('isBenefit') ? this.formValidate.isBenefit = true : this.formValidate.isBenefit = false;
      this.checkboxGroup.includes('isBest') ? this.formValidate.isBest = true : this.formValidate.isBest = false;
      this.checkboxGroup.includes('isNew') ? this.formValidate.isNew = true : this.formValidate.isNew = false;
      this.checkboxGroup.includes('isHot') ? this.formValidate.isHot = true : this.formValidate.isHot = false;
    },
    watCh: function watCh(val) {
      var _this2 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this2.attrInfo[key]) _this2.ManyAttrValue[index] = _this2.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this2.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    // cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                // cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              // Object.values(res[kk].attrValue).forEach((v, i) => {
              //   res[kk]['value' + i] = v
              // })
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 添加规则；
    addRule: function addRule() {
      var _this = this;
      this.$modalAttr(this.formDynamics, function () {
        _this.productGetRule();
      });
    },
    // 选择规格
    onChangeSpec: function onChangeSpec(num) {
      this.isAttr = true;
      if (!num) {
        return;
      }
      if (this.hasPermission(['admin:product:rule:list'])) {
        this.productGetRule();
      }
    },
    hasPermission: function hasPermission(value) {
      return checkPermi(value);
    },
    // 选择属性确认
    confirm: function confirm() {
      var _this3 = this;
      this.isAttr = true;
      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }
      var data = [];
      this.ruleList.forEach(function (item) {
        if (item.id === _this3.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            data.push({
              attrName: i.value,
              attrValue: i.detail
            });
          });
        }
        _this3.formValidate.attr = data;
      });
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this4 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this4.merCateList = _this4.filerMerCateList(res);
        var newArr = [];
        res.forEach(function (value, index) {
          newArr[index] = value;
          if (value.child) {
            newArr[index].child = value.child.filter(function (item) {
              return item.status === true;
            });
            if (value.name == '打印') {
              value.child.forEach(function (item) {
                _this4.printCategoryPaperList.push(item);
              });
            } else if (value.name == '装订') {
              value.child.forEach(function (item) {
                _this4.printCategoryWrapperList.push(item);
              });
            }
          }
        }); //过滤商品分类设置为隐藏的子分类不出现在树形列表里
        _this4.merCateList = _this4.filerMerCateList(newArr);
      });
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this5 = this;
      templateListApi(this.tableFrom).then(function (res) {
        var list = res.recordList;
        console.log(list);
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this5.ruleList = list;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this6 = this;
      shippingTemplatesList(this.tempData).then(function (res) {
        _this6.shippingList = res.recordList;
      });
    },
    showInput: function showInput(item) {
      this.$set(item, 'inputVisible', true);
    },
    onChangetype: function onChangetype(item) {
      var _this7 = this;
      if (item === 1) {
        this.OneattrValue.map(function (item) {
          _this7.$set(item, 'brokerage', null);
          _this7.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          _this7.$set(item, 'brokerage', null);
          _this7.$set(item, 'brokerageTwo', null);
        });
      } else {
        this.OneattrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;
          _this7.$set(item, 'brokerage', null);
          _this7.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;
        });
      }
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(index) {
      this.ManyAttrValue.splice(index, 1);
    },
    // 批量添加
    batchAdd: function batchAdd() {
      // if (!this.oneFormBatch[0].pic || !this.oneFormBatch[0].price || !this.oneFormBatch[0].cost || !this.oneFormBatch[0].ot_price ||
      //     !this.oneFormBatch[0].stock || !this.oneFormBatch[0].bar_code) return this.$Message.warning('请填写完整的批量设置内容！');
      var _iterator = _createForOfIteratorHelper(this.ManyAttrValue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          this.$set(val, 'image', this.oneFormBatch[0].image);
          this.$set(val, 'price', this.oneFormBatch[0].price);
          // this.$set(val, 'cost', this.oneFormBatch[0].cost)
          this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
          //批量只影响新增的
          if (!val.id) {
            this.$set(val, 'stock', this.oneFormBatch[0].stock);
          }
          this.$set(val, 'pointsOtPrice', this.oneFormBatch[0].pointsOtPrice);
          this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
          this.$set(val, 'weight', this.oneFormBatch[0].weight);
          this.$set(val, 'volume', this.oneFormBatch[0].volume);
          this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
          this.$set(val, 'brokerageTwo', this.oneFormBatch[0].brokerageTwo);
          this.$set(val, 'pointsPrice', this.oneFormBatch[0].pointsPrice);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // 添加按钮
    addBtn: function addBtn() {
      this.clearAttr();
      this.isBtn = true;
    },
    // 取消
    offAttrName: function offAttrName() {
      this.isBtn = false;
    },
    clearAttr: function clearAttr() {
      this.isAttr = true;
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveAttr: function handleRemoveAttr(index) {
      this.isAttr = true;
      this.formValidate.attr.splice(index, 1);
      this.manyFormValidate.splice(index, 1);
    },
    // 删除属性
    handleClose: function handleClose(item, index) {
      item.splice(index, 1);
    },
    initDefaultAttrs: function initDefaultAttrs() {
      this.isAttr = true;
      // 默认规格列表，可根据需要扩展
      var defaultAttrs = [{
        attrName: '打印材质',
        attrValue: [] // 初始值为空数组，后续可通过现有逻辑添加具体值
      }, {
        attrName: '打印面数',
        attrValue: [] // 初始值为空数组
      }];

      // 先清空现有规格（可选：如果需要保留原有规格，可移除这行）
      this.formValidate.attr = [];
      var hash = {};
      // 合并默认规格并去重（防止重复初始化）
      this.formValidate.attr = defaultAttrs.reduce(function (item, next) {
        if (!hash[next.attrName]) {
          hash[next.attrName] = true;
          item.push(next);
        }
        return item;
      }, _toConsumableArray(this.formValidate.attr)); // 保留原有规格（如需覆盖可改为 []）

      this.isBtn = false;
      console.log('默认规格初始化完成', this.formValidate.attr);
    },
    // 添加规则名称
    createAttrName: function createAttrName() {
      this.isAttr = true;
      if (this.formDynamic.attrsName && this.formDynamic.attrsVal) {
        var data = {
          attrName: this.formDynamic.attrsName,
          attrValue: [this.formDynamic.attrsVal]
        };
        this.formValidate.attr.push(data);
        var hash = {};
        this.formValidate.attr = this.formValidate.attr.reduce(function (item, next) {
          /* eslint-disable */
          hash[next.attrName] ? '' : hash[next.attrName] = true && item.push(next);
          return item;
        }, []);
        this.clearAttr();
        this.isBtn = false;
      } else {
        this.$Message.warning('请添加完整的规格！');
      }
    },
    // 添加属性
    createAttr: function createAttr(num, idx) {
      this.isAttr = true;
      if (num) {
        this.formValidate.attr[idx].attrValue.push(num);
        var hash = {};
        this.formValidate.attr[idx].attrValue = this.formValidate.attr[idx].attrValue.reduce(function (item, next) {
          /* eslint-disable */
          hash[next] ? '' : hash[next] = true && item.push(next);
          return item;
        }, []);
        this.formValidate.attr[idx].inputVisible = false;
      } else {
        this.$message.warning('请添加属性');
      }
    },
    //点击展示所有多规格属性
    showAllSku: function showAllSku() {
      if (this.isAttr == false) {
        this.isAttr = true;
        if (this.formValidate.specType && this.isAttr) this.watCh(this.formValidate.attr); //重要！！！
      } else if (this.isAttr == true) {
        this.isAttr = false;
        this.getInfo();
      }
    },
    getCustomConfig: function getCustomConfig() {
      var _this8 = this;
      systemConfigApi.configInfo({
        id: '147'
      }).then(function (data) {
        console.log('dddddddddd111111111');
        _this8.customConfig = data;
        if (_this8.customConfig.tenantKey == 'shucaipifa') {
          _this8.stepInput = false;
        }
        if (_this8.customConfig.mallType == 2) {
          _this8.onChangePrintInputType(_this8.printInputType);
          _this8.formThead = Object.assign({}, {
            price: {
              title: '售价'
            },
            stock: {
              title: '库存'
            }
          });
          console.log('this..');
          _this8.OneattrValue = [Object.assign({}, {
            price: 0,
            stock: 0
          })];
          _this8.ManyAttrValue = [Object.assign({}, {
            price: 0,
            stock: 0
          })];
        } else if (_this8.bizType == 3) {
          _this8.formThead = Object.assign({}, {
            price: {
              title: '租金/天'
            },
            depositPrice: {
              title: '押金'
            },
            stock: {
              title: '库存'
            }
          });
          console.log('this..');
          _this8.OneattrValue = [Object.assign({}, {
            price: 0,
            depositPrice: 0,
            stock: 0
          })];
          _this8.ManyAttrValue = [Object.assign({}, {
            price: 0,
            depositPrice: 0,
            stock: 0
          })];
        }
      });
    },
    // 详情
    getInfo: function () {
      var _getInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this9 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.fullscreenLoading = true;

              //加载配置
              _context2.next = 3;
              return this.getCustomConfig();
            case 3:
              console.log('等1');
              _context2.next = 6;
              return this.getCategorySelect();
            case 6:
              console.log('等2');
              productDetailApi(this.$route.params.id).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var info, categoryIds, sliderRaw, specList, skuList, specMode, parseJson, normalizeSku, first, second, imgs, manyAttr, tmp, tmpTab;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        console.log('dddddddddd33333');
                        console.log('等3');
                        // this.isAttr = true;
                        info = res;
                        categoryIds = info.categoryIds || info.cateId || '';
                        sliderRaw = info.sliderImages != null ? info.sliderImages : info.sliderImage;
                        specList = info.specList || info.attr || [];
                        skuList = info.skuList || info.attrValue || [];
                        specMode = !!(info.specMode != null ? info.specMode : info.specType);
                        parseJson = function parseJson(val, fallback) {
                          if (val == null || val === '') return fallback;
                          if (typeof val !== 'string') return val;
                          try {
                            return JSON.parse(val);
                          } catch (e) {
                            return fallback;
                          }
                        };
                        normalizeSku = function normalizeSku(val) {
                          var row = _objectSpread({}, val);
                          if (row.image) row.image = _this9.$selfUtil.setDomain(row.image);
                          if (row.marketPrice != null && row.otPrice == null) row.otPrice = row.marketPrice;
                          var rawMap = row.specMap != null ? row.specMap : row.attrValue;
                          row.attrValue = parseJson(rawMap, {}) || {};
                          return row;
                        };
                        if (_this9.customConfig.mallType == 2) {
                          _this9.currentPrintCategoryId = parseInt(String(categoryIds).split(',')[0]);
                          first = _this9.printCategoryPaperList.find(function (x) {
                            return x.id == _this9.currentPrintCategoryId;
                          });
                          second = _this9.printCategoryWrapperList.find(function (x) {
                            return x.id == _this9.currentPrintCategoryId;
                          });
                          if (first) {
                            _this9.printInputType = 1;
                          } else if (second) {
                            _this9.printInputType = 2;
                          }
                        }
                        _this9.formValidate = {
                          image: _this9.$selfUtil.setDomain(info.image || info.mainImage || ''),
                          sliderImage: typeof sliderRaw === 'string' ? sliderRaw : JSON.stringify(sliderRaw || []),
                          verticalPosterImage: info.verticalPosterImage || '',
                          sliderImages: [],
                          storeName: info.productName || info.storeName,
                          storeInfo: info.productIntro || info.storeInfo,
                          keyword: info.keywords || info.keyword,
                          cateIds: categoryIds ? String(categoryIds).split(',') : [],
                          cateId: categoryIds,
                          unitName: info.unit || info.unitName,
                          sort: info.sort,
                          isShow: info.publishStatus != null ? info.publishStatus : info.isShow,
                          isBenefit: info.isDiscount != null ? info.isDiscount : info.isBenefit,
                          isNew: info.isNew,
                          isGood: info.isHighQuality != null ? info.isHighQuality : info.isGood,
                          isHot: info.isHot,
                          isBest: info.isRecommend != null ? info.isRecommend : info.isBest,
                          tempId: info.freightTemplateId != null ? info.freightTemplateId : info.tempId,
                          attr: [],
                          attrValue: [],
                          selectRule: info.selectRule,
                          isSub: info.commissionSingle != null ? info.commissionSingle : info.isSub,
                          content: _this9.$selfUtil.replaceImgSrcHttps(info.content),
                          specType: specMode,
                          id: info.id,
                          giveIntegral: info.giveIntegral,
                          ficti: info.fictitiousSales != null ? info.fictitiousSales : info.ficti,
                          coupons: info.coupons,
                          couponIds: info.couponIds,
                          activity: Array.isArray(info.activity) ? info.activity : info.activityStr ? info.activityStr.split(',') : ['默认', '秒杀', '砍价', '拼团']
                        };
                        marketingSendApi({
                          type: 3
                        }).then(function (res) {
                          if (_this9.formValidate.couponIds !== null) {
                            var ids = _this9.formValidate.couponIds.toString();
                            var arr = res.recordList;
                            var obj = {};
                            for (var i in arr) {
                              obj[arr[i].id] = arr[i];
                            }
                            var strArr = ids.split(',');
                            var newArr = [];
                            var _iterator2 = _createForOfIteratorHelper(strArr),
                              _step2;
                            try {
                              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                var item = _step2.value;
                                if (obj[item]) {
                                  newArr.push(obj[item]);
                                }
                              }
                            } catch (err) {
                              _iterator2.e(err);
                            } finally {
                              _iterator2.f();
                            }
                            _this9.$set(_this9.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
                          }
                        });
                        imgs = parseJson(sliderRaw, []);
                        if (!Array.isArray(imgs) && imgs && _typeof(imgs) === 'object') {
                          imgs = Object.keys(imgs).map(function (i) {
                            return imgs[i];
                          });
                        }
                        if (!Array.isArray(imgs)) imgs = [];
                        _this9.formValidate.sliderImages = imgs.map(function (i) {
                          return _this9.$selfUtil.setDomain(i);
                        });
                        if (info.isHot) _this9.checkboxGroup.push('isHot');
                        if (_this9.formValidate.isGood) _this9.checkboxGroup.push('isGood');
                        if (_this9.formValidate.isBenefit) _this9.checkboxGroup.push('isBenefit');
                        if (_this9.formValidate.isBest) _this9.checkboxGroup.push('isBest');
                        if (info.isNew) _this9.checkboxGroup.push('isNew');
                        if (checkPermi(['admin:product:rule:list'])) {
                          _this9.productGetRule();
                        }
                        if (specMode) {
                          _this9.formValidate.attr = (specList || []).map(function (item) {
                            return {
                              id: item.id,
                              attrName: item.specName || item.attrName,
                              attrValue: String(item.specValues || item.attrValues || '').split(',').filter(Boolean)
                            };
                          });
                          _this9.ManyAttrValue = (skuList || []).map(normalizeSku);
                          _this9.ManyAttrValue.forEach(function (val) {
                            _this9.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
                          });
                          _this9.formValidate.attrValue = _this9.ManyAttrValue;
                          /***多规格商品如果被删除过sku，优先展示api返回的数据,否则会有没有删除的错觉***/
                          manyAttr = _this9.attrFormat(_this9.formValidate.attr);
                          if (manyAttr.length !== _this9.ManyAttrValue.length) {
                            _this9.$set(_this9, 'showAll', true);
                            _this9.isAttr = false;
                          } else {
                            _this9.isAttr = true;
                          }
                          /*******/
                          tmp = {};
                          tmpTab = {};
                          _this9.formValidate.attr.forEach(function (o, i) {
                            tmp[o.attrName] = {
                              title: o.attrName
                            };
                            tmpTab[o.attrName] = '';
                          });

                          // 此处手动实现后台原本value0 value1的逻辑
                          _this9.formValidate.attrValue.forEach(function (item) {
                            for (var attrValueKey in item.attrValue) {
                              item[attrValueKey] = item.attrValue[attrValueKey];
                            }
                          });
                          _this9.manyTabTit = tmp;
                          _this9.manyTabDate = tmpTab;
                          _this9.formThead = Object.assign({}, _this9.formThead, tmp);
                        } else {
                          _this9.OneattrValue = (skuList || []).map(normalizeSku);
                          _this9.formValidate.attr = []; //单规格商品规格设置为空
                        }
                        _this9.fullscreenLoading = false;
                      case 25:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (res) {
                _this9.fullscreenLoading = false;
                console.log(res);
                _this9.$message.error(res.message);
              });
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].thumbnailPath;
          _this.OneattrValue[0].image = img[0].thumbnailPath;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning("最多选择10张图片！");
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.thumbnailPath);
          });
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].thumbnailPath;
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].thumbnailPath;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].thumbnailPath;
        }
      }, tit, 'content');
    },
    // ========== 原有方法名不变（仅做逻辑分发） ==========
    handleSubmitUp: function handleSubmitUp() {
      this.customConfig.mallType === 1 ? this.handleUpType1() : this.handleUpType2();
    },
    handleSubmitNest: function handleSubmitNest(name) {
      var _this10 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this10.customConfig.mallType == 1 ? _this10.handleNextType1() : _this10.handleNextType2();
        } else {
          // 校验失败提示（通用逻辑）
          if (!_this10.formValidate.store_name || !_this10.formValidate.cate_id || !_this10.formValidate.keyword || !_this10.formValidate.unit_name || !_this10.formValidate.store_info || !_this10.formValidate.image || !_this10.formValidate.slider_image) {
            _this10.$message.warning("请填写完整商品信息！");
          }
        }
      });
    },
    // ========== 按类型拆分的独立子方法（逻辑隔离） ==========
    // mallType=1：原有3步流程逻辑
    handleUpType1: function handleUpType1() {
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    handleNextType1: function handleNextType1() {
      if (this.currentTab++ > 2) this.currentTab = 0;
    },
    // mallType=2：仅1、3步流程逻辑
    handleUpType2: function handleUpType2() {
      // 步骤3（2）→ 步骤1（0），步骤1（0）→ 保持0
      this.currentTab = this.currentTab === 2 ? 0 : 0;
    },
    handleNextType2: function handleNextType2() {
      // 步骤1（0）→ 步骤3（2），步骤3（2）→ 步骤1（0）
      this.currentTab = this.currentTab === 0 ? 2 : 0;
    },
    // 提交
    handleSubmit: Debounce(function (name) {
      var _this11 = this;
      try {
        this.onChangeGroup();

        // 1. 验证基本数据完整性
        if (this.formValidate.specType && (!Array.isArray(this.formValidate.attr) || this.formValidate.attr.length < 1)) {
          return this.$message.warning("请填写多规格属性！");
        }

        // 2. 深度克隆原始数据（带保护）
        var cloneData = function cloneData(data) {
          try {
            return JSON.parse(JSON.stringify(data));
          } catch (e) {
            console.error('克隆数据失败:', e);
            return Array.isArray(data) ? _toConsumableArray(data) : _objectSpread({}, data);
          }
        };

        // 3. 保存完整的原始状态
        var originalState = {
          formValidate: _objectSpread(_objectSpread({}, cloneData(this.formValidate)), {}, {
            attr: Array.isArray(this.formValidate.attr) ? cloneData(this.formValidate.attr) : [],
            attrValue: Array.isArray(this.formValidate.attrValue) ? cloneData(this.formValidate.attrValue) : []
          }),
          ManyAttrValue: Array.isArray(this.ManyAttrValue) ? cloneData(this.ManyAttrValue) : [],
          OneattrValue: Array.isArray(this.OneattrValue) ? cloneData(this.OneattrValue) : []
        };

        // 4. 准备提交数据（带保护）——字段对齐后端 StoreProductAddRequest
        var prepareSubmitData = function prepareSubmitData() {
          var mapSku = function mapSku(item) {
            var newItem = _objectSpread({}, item);
            delete newItem.value0;
            delete newItem.attrValue;
            delete newItem.otPrice;
            newItem.marketPrice = item.marketPrice != null ? item.marketPrice : item.otPrice;
            newItem.specMap = _typeof(item.attrValue) === 'object' ? JSON.stringify(item.attrValue) : item.attrValue || item.specMap || '{}';
            return newItem;
          };
          var formData = {
            id: _this11.formValidate.id || undefined,
            image: _this11.formValidate.image,
            sliderImages: Array.isArray(_this11.formValidate.sliderImages) ? JSON.stringify(_this11.formValidate.sliderImages) : '[]',
            productName: _this11.formValidate.storeName,
            productIntro: _this11.formValidate.storeInfo,
            keywords: _this11.formValidate.keyword,
            categoryIds: Array.isArray(_this11.formValidate.cateIds) ? _this11.formValidate.cateIds.join(',') : '',
            unit: _this11.formValidate.unitName,
            sort: _this11.formValidate.sort,
            isHot: _this11.formValidate.isHot,
            isDiscount: _this11.formValidate.isBenefit,
            isRecommend: _this11.formValidate.isBest,
            isNew: _this11.formValidate.isNew,
            isHighQuality: _this11.formValidate.isGood,
            giveIntegral: _this11.formValidate.giveIntegral,
            commissionSingle: !!_this11.formValidate.isSub,
            fictitiousSales: _this11.formValidate.ficti || 0,
            freightTemplateId: _this11.formValidate.tempId,
            specMode: !!_this11.formValidate.specType,
            activity: _this11.formValidate.activity,
            content: _this11.formValidate.content || '',
            couponIds: _this11.formValidate.couponIds,
            verticalPosterImage: _this11.formValidate.verticalPosterImage,
            bizType: _this11.bizType
          };
          if (_this11.formValidate.specType) {
            formData.specList = (_this11.formValidate.attr || []).map(function (item) {
              return {
                id: item.id,
                specName: item.attrName || '',
                specValues: Array.isArray(item.attrValue) ? item.attrValue.join(',') : ''
              };
            });
            formData.skuList = (_this11.ManyAttrValue || []).map(mapSku);
          } else {
            formData.specList = [{
              specName: '规格',
              specValues: '默认',
              id: _this11.$route.params.id ? _this11.formValidate.attr && _this11.formValidate.attr[0] && _this11.formValidate.attr[0].id : undefined
            }];
            formData.skuList = (_this11.OneattrValue || [{}]).map(function (item) {
              return _objectSpread(_objectSpread({}, mapSku(item)), {}, {
                specMap: JSON.stringify({
                  '规格': '默认'
                })
              });
            });
          }
          return formData;
        };

        // 5. 恢复原始状态的函数
        var restoreOriginalState = function restoreOriginalState() {
          _this11.formValidate = _objectSpread(_objectSpread({}, originalState.formValidate), {}, {
            attr: originalState.formValidate.attr || [],
            attrValue: originalState.formValidate.attrValue || []
          });
          if (_this11.formValidate.specType) {
            _this11.ManyAttrValue = originalState.ManyAttrValue.length ? originalState.ManyAttrValue : [{}];
          } else {
            _this11.OneattrValue = originalState.OneattrValue.length ? originalState.OneattrValue : [{}];
          }
        };

        // 6. 表单验证
        this.$refs[name].validate(function (valid) {
          if (!valid) {
            var missingFields = [!_this11.formValidate.storeName && '商品名称', !_this11.formValidate.cateIds && '商品分类', !_this11.formValidate.keyword && '商品关键字', !_this11.formValidate.unitName && '单位', !_this11.formValidate.storeInfo && '商品简介', !_this11.formValidate.image && '商品封面图', !_this11.formValidate.sliderImages && '商品轮播图'].filter(Boolean);
            return _this11.$message.warning("\u8BF7\u586B\u5199\u5B8C\u6574\u5546\u54C1\u4FE1\u606F\uFF01\u7F3A\u5C11\uFF1A".concat(missingFields.join('、')));
          }
          if (_this11.customConfig.mallType == 2) {
            _this11.formValidate.unitName = '件';
            _this11.formValidate.storeInfo = '打印商品';
            _this11.formValidate.image = 'NOT_NEED';
          }

          // 7. 提交数据
          _this11.fullscreenLoading = true;
          var submitData = prepareSubmitData();
          var apiCall = _this11.$route.params.id ? productUpdateApi : productCreateApi;
          apiCall(submitData).then(function (res) {
            _this11.$message.success(_this11.$route.params.id ? '编辑成功' : '新增成功');
            setTimeout(function () {
              _this11.closeOpenPageAndGo({
                path: _this11.listUrl,
                query: {
                  refresh: '1',
                  type: _this11.tabIndex
                }
              });
            }, 500);
          }).catch(function (error) {
            console.error('API调用失败:', error);
            restoreOriginalState();
            _this11.$message.error(error.message);
          }).finally(function () {
            _this11.fullscreenLoading = false;
          });
        });
      } catch (error) {
        console.error('处理表单时发生错误:', error);
        this.$message.error('系统错误，请刷新页面后重试');
        this.fullscreenLoading = false;
      }
    }),
    closeOpenPageAndGo: function closeOpenPageAndGo(obj) {
      this.$store.dispatch("tagsView/delView", this.$route);
      if (obj !== undefined) {
        this.$router.push(obj);
      }
    },
    goBack: function goBack() {
      var listPath = this.listUrl || this.$route.meta && this.$route.meta.activeMenu;
      if (!listPath) {
        this.$router.go(-1);
        return;
      }
      this.$store.dispatch('tagsView/delView', this.$route);
      this.$router.push({
        path: listPath
      });
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    },
    handleDragEnterFont: function handleDragEnterFont(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.activity);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.activity = newItems;
      }
    },
    getGoodsType: function getGoodsType() {
      var _this12 = this;
      /** 让商品推荐列表的name属性与页面设置tab的name匹配**/
      goodDesignList({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [],
          arr1 = [];
        // const listArr = [{ name: '是否热卖', value: 'isGood' }];
        var listArr = [];
        var typeLists = [{
          name: '',
          value: 'isHot',
          type: '2'
        },
        //热门榜单
        {
          name: '',
          value: 'isBenefit',
          type: '4'
        },
        //促销单品
        {
          name: '',
          value: 'isBest',
          type: '1'
        },
        //精品推荐
        {
          name: '',
          value: 'isNew',
          type: '3'
        }]; //首发新品
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this12.recommend = listArr;
      });
    }
  }
};